import {Component, Input, OnInit} from '@angular/core';
import {ViewField} from "../../core/definitions/object-view";
import { FeatureFlagsService } from '../../core/feature-flags.service';

@Component({
    selector: 'app-object-view-show-more',
    templateUrl: './object-view-show-more.component.html',
    styleUrls: ['./object-view-show-more.component.scss'],
    standalone: false
})
export class ObjectViewShowMoreComponent implements OnInit {
  @Input() field: ViewField;
  listName: string;

  constructor(
    private readonly featureFlags: FeatureFlagsService
  ) {}

  ngOnInit() {
    if (['children', 'parents', 'relationships'].includes(this.field.field_name)) {
      this.listName = this.field.field_name
    }
  }

  get newListViewRouterLink(): string {
    return location.pathname.replace('overview', 'children');
  }

  protected readonly newObjectView = this.featureFlags.getFeatureFlags()?.experimental?.useNewObjectPage;
}
